/**
 * App - Main application component following MVVM architecture
 * This component serves as the composition root, connecting View and ViewModel layers
 * 
 * MVVM Architecture:
 * - Model (model/OcrModel.js): Handles data and business logic
 * - View (view/*.js): Pure presentation components with no business logic
 * - ViewModel (viewmodel/AppViewModel.js): Manages UI state and coordinates View-Model interaction
 */

import React from 'react';
import useAppViewModel from './viewmodel/AppViewModel';
import PrivacyPolicy from './PrivacyPolicy';
import {
  Header,
  Footer,
  ControlsSection,
  ScrambleSection,
  MovesSection,
  SolutionViewer
} from './view';
import './App.css';

function App() {
  if (typeof window !== 'undefined' && window.location && window.location.pathname === '/privacy-policy') {
    return <PrivacyPolicy />;
  }

  const viewModel = useAppViewModel();

  return (
    <div className="app-container">
      <Header />

      <ControlsSection viewModel={viewModel} />

      <ScrambleSection 
        scramble={viewModel.scramble}
        isEditing={viewModel.editingScramble}
        editValue={viewModel.scrambleEditValue}
        isLocked={viewModel.scrambleLocked}
        onEdit={viewModel.startEditingScramble}
        onSave={viewModel.saveEditedScramble}
        onCancel={viewModel.cancelEditingScramble}
        onEditChange={viewModel.updateScrambleEditValue}
        onToggleLock={viewModel.toggleScrambleLock}
      />

      <MovesSection viewModel={viewModel} />

      {viewModel.hasResults() && (
        <SolutionViewer scramble={viewModel.scramble} moves={viewModel.moves} />
      )}

      <Footer />
    </div>
  );
}

export default App;
